/*
We're constantly improving the code you see. 
Please share your feedback here: https://form.asana.com/?k=uvp-HPgd3_hyoXRBw1IcNg&d=1152665201300829
*/

import React from 'react';
import { Button } from '../Button';
import { Link } from '../Link';
import { Logo } from '../Logo';
import './style.css';

import { LogoPartner } from '../LogoPartner';

import { useNavigate } from 'react-router-dom';

export const HeaderDesktop = ({
    className,
    logoDimensions,
    shareFeedbackEmailAddress,
}) => {
    const navigate = useNavigate();

    /*
	align-items: flex-start;
    align-self: stretch;
    display: flex;
    flex: 0 0 auto;
    flex-wrap: wrap;
    gap: 64px 64px;
    justify-content: end;
    position: relative;
    width: 100%;
*/
    return (
        <div className={`header ${className}`}>
            <div className="frame">
                <div
                    className="logo-wrapper"
                    style={{ display: 'inline-block' }}
                >
                    <Logo
                        className="logo"
                        logo="DUO"
                        logoDimensions={logoDimensions}
                        style={{
                            cursor: 'pointer',
                            colour: 'default',
                            float: 'left',
                        }}
                        onClick={() => {
                            navigate('/');
                        }}
                    />

                    <div
                        className="partner-logos"
                        style={{
                            float: 'left',
                            justifyContent: 'start',
                            width: 'unset',
                            marginLeft: '3em',
                            position: 'relative',
                            lineHeight: '120px',
                        }}
                    >
                        <LogoPartner
                            className="design-component-instance-node-8"
                            color="default"
                            lernenDigital="/img/lernen-digital-transferstelle-anthrazit-rgb-1-2x.png"
                            partner="lernen-digital"
                            size="mobile"
                        />
                        <LogoPartner
                            className="design-component-instance-node-8"
                            color="black"
                            partner="uni-t-b"
                            size="mobile"
                        />
                    </div>
                </div>

                <div className="frame-right">
                    <div>
                        <div
                            style={{
                                marginBottom: '25px',
                                marginTop: '-65px',
                            }}
                        ></div>

                        <div className="nav">
                            <div className="links">
                                <Link
                                    className="link-item"
                                    text="Materialien"
                                    onClick={() => {
                                        navigate('/directory');
                                    }}
                                />
                                <Link
                                    className="link-item"
                                    text="Das Projekt"
                                    onClick={() => {
                                        navigate('/project');
                                    }}
                                />
                                <Link
                                    className="link-item"
                                    text="FAQ"
                                    onClick={() => {
                                        navigate('/faq');
                                    }}
                                />
								<Link
                                    className="link-item"
                                    text="eduBuzz"
                                    onClick={() => {
										window.open("https://edubuzz.tuecede.de", '_blank').focus();
                                    }}
                                />
                            </div>

                            <Button
                                className="feedback-button"
                                status="default"
                                style="secondary"
                                textLink="Feedback teilen"
                                onClick={(e) => {
                                    window.location =
                                        'mailto:' + shareFeedbackEmailAddress;
                                }}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

HeaderDesktop.propTypes = {};
